<template>
    <div class="wrapper">
        <p class="title">{{ $t("userAMLQuestionnaire.thirdStep.labelOne") }}</p>
        <p class="message message--1">{{ $t("userAMLQuestionnaire.thirdStep.labelTwo") }}</p>
        <p class="message message--2">{{ $t("userAMLQuestionnaire.thirdStep.labelThree") }}</p>

        <div class="inputs-wrapper">
            <div class="currency">
                <label class="label">
                    {{ $t('userAMLQuestionnaire.thirdStep.labelFour') }}:
                </label>
                <multiselect v-model="selectedCurrency"
                    :options="formattedCurrenciesList"
                    :allow-empty="false"
                    :show-labels="false"
                    track-by="display"
                    label="display"
                    :placeholder="$t('userAMLQuestionnaire.thirdStep.labelFour')"
                    :class="['label__input', { 'label__input--active': selectedCurrency }]"
                    searchable
                    @input="onCurrencyChange"
                >
                    <template slot="singleLabel"
                        slot-scope="props"
                    >
                        {{ props.option.display }}
                    </template>
                    <template slot="option"
                        slot-scope="props"
                    >
                        {{ props.option.display }}
                    </template>
                    <span slot="noResult">{{ $t('userAMLQuestionnaire.noResults') }}</span>
                </multiselect>
            </div>
            <custom-input v-model.trim="amount"
                name="amount"
                type="text"
                class="amount"
                :label="$t('userAMLQuestionnaire.thirdStep.labelFive')"
                :placeholder="$t('userAMLQuestionnaire.thirdStep.placeholder')"
                :validations="amountValidations"
                required
                :hideHint="init"
                :isValid.sync="isAmountValid"
                @input="onAmountChange"
            />
        </div>
    </div>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
} from 'vuex';

// Validations
import {
    amlAmountFormat,
} from '@shared/validations/customer-first';

// Components
import customInput from '@webapp/components/form/custom-input.vue';

export default {
    name: 'question-3',
    components: {
        customInput,
    },
    data() {
        return {
            amount: '',
            selectedCurrency: null,
            isAmountValid: false,
            init: true,
        };
    },
    computed: {
        ...mapGetters(['fiatCurrenciesList', 'preferredFiatCurrency']),

        formattedCurrenciesList() {
            return this.fiatCurrenciesList.map((currency) => ({
                display: currency.shortCode,
                value: currency.shortCode,
            }));
        },

        preferredCurrency() {
            const value = this.preferredFiatCurrency.shortCode || this.fiatCurrenciesList[0].shortCode;

            return {
                display: value,
                value,
            };
        },

        amountValidations() {
            return [amlAmountFormat];
        },
    },
    mounted() {
        this.selectedCurrency = this.preferredCurrency;
    },
    methods: {
        onCurrencyChange() {
            this.validateCondition();
        },
        onAmountChange() {
            this.validateCondition();
        },
        async validateCondition() {
            this.init = false;
            await this.$nextTick();
            if (this.isAmountValid) {
                this.$emit('completed', {
                    spendingCurrency: this.selectedCurrency.value,
                    spendingEstimate: this.amount,
                });
            } else {
                this.$emit('in-progress');
            }
        },
        resetStep() {
            this.amount = '';
            this.init = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    .title {
        font-size: 1.75rem;
        line-height: 23px;
    }

    .message {
        font-size: 1.4rem;
        line-height: 18px;
        font-weight: bold;

        &--1 {
            margin-top: 30px;
            margin-bottom: 0;
        }

        &--2 {
            margin-top: 0;
            margin-bottom: 30px;
        }
    }

    .inputs-wrapper {
        display: flex;

        .currency {
            width: 80px;
        }

        .amount {
            margin-left: 3rem;
            max-width: 400px;
            padding-bottom: 0.3rem;
        }
    }
}
</style>